// extracted by mini-css-extract-plugin
export default {"wrapper":"u1-z","play":"v1-z"};